<template>
  <v-layout>
    <v-flex>
      <v-row justify="end" align="center">
        <v-col sm="6">
          <h2>Follow Ups</h2>
        </v-col>
        <v-spacer />
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mr-3 mb-3"
              v-on="on"
              small
              fab
              dark
              color="primary"
              @click="onCreateNew"
            >
              <v-icon dark>add</v-icon>
            </v-btn>
          </template>
          <span>Add new follow up</span>
        </v-tooltip>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="$apollo.loading"
        :search="search"
        item-key="`[${item.id},${item._uid},${item.name},${item.isComplete}]`"
        class="elevation-1"
        hide-default-footer
        mobile-break-point="1264"
      >
        <template v-slot:item.updatedAt="{ item }">
          {{ item.updatedAt | formatDate }}
        </template>
        <template v-slot:item.dueDate="{ item }">
          {{ item.dueDate | formatDate }}
        </template>
        <template v-slot:item.isComplete="{ item }">
          <v-simple-checkbox
            v-model="item.isComplete"
            :disabled="true"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <default-list-actions
            :item="item"
            hide-view
            @deleteItem="onDeleteItem"
            @editItem="onEditItem"
          ></default-list-actions>
        </template>
      </v-data-table>
      <edit-action-dialog
        :show="showActionEditor"
        @close="showActionEditor = false"
        v-model="editedAction"
        @input="onSave"
      ></edit-action-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import { ListMixin } from "../../../../mixins/ListMixin";
import EditActionDialog from "./EditActionDialog";
import DefaultListActions from "../../shared/DefaultListActions";
export default {
  name: "itinerary-task-action-list",
  components: { EditActionDialog, DefaultListActions },
  mixins: [ListMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      debug: false,
      editedAction: {},
      //items: this.items ? this.items : [],
      showActionEditor: false,
      search: "",
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Updated At",
          value: "updatedAt",
          name: "updatedAt",
        },
        {
          text: "Updated by",
          value: "userName",
          name: "userName",
        },
        {
          text: "Due Date",
          value: "dueDate",
          name: "dueDate",
        },
        {
          text: "Complete",
          value: "isComplete",
          name: "isComplete",
        },
        {
          text: "Edit/Delete",
          value: "actions",
          name: "actions",
        },
      ],
    };
  },
  watch: {
    value(newVal) {
      this.items = newVal;
    },
  },
  methods: {
    onCreateNew() {
      this.editedAction = { name: "New Follow Up", isComplete: false };
      this.showActionEditor = true;
    },
    onEditItem(item) {
      this.editedAction = { ...item };
      this.showActionEditor = true;
    },
    onDeleteItem(item) {
      this.$emit("delete", item);
    },
    onSave(item) {
      this.$emit("save", item);
      this.showActionEditor = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/plugins/task-tracker/ItineraryTaskActionsList.vue